<template>
    <div class="content-wrapper">
       <div class="card p-primary border-0">
             <div class="text-justify">
                <div class="row">
                    <!-- Header -->
                    <div class="col-lg-12">
                        <clc-calendar-table-header></clc-calendar-table-header>
                    </div>

                    <!-- Detail -->
                    <div class="col-lg-12" v-if="viewClcCalendarDetailVal">
                        <clc-calendar-table-detail :clcCalendarRowData="clcCalendarRowData"></clc-calendar-table-detail>
                    </div>
                </div>
            </div>
       </div>
    </div>
</template>

<script>
import CoreLibrary from "../../../../../core/helpers/CoreLibrary.js";
import {Schema} from './Schema';
import {urlGenerator} from "../../../../Helpers/AxiosHelper";

export default {
    extends: CoreLibrary,
    name: "ClcCalendar",
    mixins: [Schema],
    inject: ["eventHub"],
    data() {
        return {
            clcCalendarRowData: {},
            viewClcCalendarDetailVal: false,
        };
    },
    created() {
        this.options.columns = [...this.tableColumns, this.actionObj];
        // this.searchAndSelectFilterOptions();
    },
    mounted() {
        this.eventHub.$on("viewClcCalendarDetailEvent", (value, data) => {
            this.viewClcCalendarDetailVal = value
            this.clcCalendarRowData = data
        })
    },
    methods: {
        /**
         * for open add edit modal
         */
        openAddEditModal() {
            this.isAddEditModalActive = true;
        },

        /**
         * for close add edit modal
         */
        closeAddEditModal() {
            let m_id = `#CLC_CALENDAR-form`;
            $(m_id).modal('hide');
            this.isAddEditModalActive = false;
            // this.searchAndSelectFilterOptions();
            this.reSetData();
        },

        /**
         * $emit Form datatable action
         */
        getListAction(rowData, actionObj, active) {
            this.rowData = rowData;

            if (actionObj.title == 'Delete') {
                this.openDeleteModal();
            } else if (actionObj.title == this.$t('edit')) {
                this.selectedUrl = `${this.ENDPOINT}/${rowData.id}`;
                this.openAddEditModal();
            }
        },

        /**
         * for open confirmation modal
         */
        openDeleteModal() {
            this.deleteConfirmationModalActive = true;
        },

        // searchAndSelectFilterOptions() {
        //     this.axiosGet(actions.DATATABLE_SEARCH_SELECT).then(response => {
        //         let name = this.options.filters.find(element => element.title === this.$t('search_and_select'));

        //         name.option = response.data.map(name => {
        //             return {
        //                 id: name.name,
        //                 value: name.name
        //             }
        //         });
        //     });
        // },

        exportAll() {
            window.location.replace(urlGenerator(DATATABLE_EXPORT))
        }
    },
}
</script>
